<script setup>
import { computed, ref } from "vue"
import { nodeViewProps, NodeViewWrapper } from "@tiptap/vue-3"
import useNodeProps from "@/Composables/useNodeProps.js"
import Grid from "@/Components/Inputs/BlockEditor/Extension/Components/Grid.vue"
import AlgoliaCategory from "@/Components/Inputs/BlockEditor/Extension/Components/AlgoliaCategory.vue"
import AuctionCardPreview from "@/Components/Inputs/BlockEditor/Extension/Components/Auctions/AuctionCardPreview.vue"
import EditAlgoliaCategory from "@/Components/Inputs/BlockEditor/Extension/Modals/EditAlgoliaCategory.vue"
import EditableNodeWrapper from "@/Components/Inputs/BlockEditor/Extension/Components/EditableNodeWrapper.vue"

const props = defineProps({
  ...nodeViewProps,
})

let {
  limit,
  category
} = useNodeProps(props)

const options = computed(() => {
  return props.extension.options
})

let items = ref([]);

const addAuctions = (auctions) => {
  items.value = auctions
}

const limitedItems = () => {
  return items.value.slice(0, limit.value);
}
</script>

<template>
  <node-view-wrapper>
    <EditableNodeWrapper v-bind="props">
      <template #tools>
        <EditAlgoliaCategory
          v-model:categoryName="category"
          v-model:limit="limit"
          @auctions="addAuctions"
        />
      </template>

      <template #content>
        <div class="w-full">
          <div class="not-prose flex mb-8">
            <h1 class="text-2xl font-bold"> {{ category ? category : __('No Category Selected') }} </h1>
            <span class="text-sm pl-1 mt-auto text-gray-400 font-bold"> {{ limitedItems().length }} products </span>
          </div>

          <div class="not-prose">
            <AlgoliaCategory
              :show-filters="true"
              :default-index="options.defaultIndex"
              :variant-filters="options.variantFilters"
              :items="limitedItems()"
              :limit="limit"
            >
              <template #auctions>
                <div v-if="items.length > 0">
                  <Grid :cols="4" :spacing="3">
                    <AuctionCardPreview v-for="auction in limitedItems()" :auction="auction" />
                  </Grid>
                </div>

                <div v-if="!category" class="w-full flex justify-center text-xl text-gray-400">
                  {{ __('Select a category') }}
                </div>
              </template>
            </AlgoliaCategory>
          </div>
        </div>
      </template>
    </EditableNodeWrapper>
  </node-view-wrapper>
</template>
